import { escapeRegExp } from "lodash-es";

/**
 * @deprecated Old function to get url domain name
 * TODO: Double check and rewrite it using URL if possible
 */
export const getUrlDomainName = (url: string): string | undefined => {
  const match = url.match(/^(https?:\/\/)?([^/]+)/);
  return match ? match[2] : undefined;
};

export const parseUrl = (url: string): undefined | URL => {
  try {
    return new URL(url);
  } catch {
    return undefined;
  }
};

export const addSchemeToUrlIfEmpty = (url: string, defaultScheme: string = "https"): string => {
  if (parseUrl(url)) {
    return url;
  }

  return `${defaultScheme}://${url}`;
};

export const removeSchemeFromUrl = (url: string, scheme: string = "https") =>
  url.replace(new RegExp(`^${escapeRegExp(scheme)}?:\\/?\\/?`), "");

// "*" in an allowed origin stands for exactly one subdomain label.
export const isOriginAllowed = (origin: string, allowedOrigins: string[]) =>
  allowedOrigins.some((allowed) =>
    new RegExp(`^${allowed.split("*").map(escapeRegExp).join("[a-z0-9-]+")}$`).test(origin)
  );
